<template>
  <IconWrapper v-if="filled" name="information" :color="color" fillMode="fill">
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M12.756 15.693C12.756 16.107 12.42 16.443 12.006 16.443C11.592 16.443 11.256 16.107 11.256 15.693V11.394C11.256 10.98 11.592 10.644 12.006 10.644C12.42 10.644 12.756 10.98 12.756 11.394V15.693ZM11.25 8.291C11.25 7.877 11.586 7.541 12 7.541C12.414 7.541 12.75 7.877 12.75 8.291C12.75 8.705 12.414 9.073 12 9.073C11.586 9.073 11.25 8.768 11.25 8.354V8.291ZM12 2.5C6.762 2.5 2.5 6.761 2.5 12C2.5 17.238 6.762 21.5 12 21.5C17.238 21.5 21.5 17.238 21.5 12C21.5 6.761 17.238 2.5 12 2.5Z"
        fill="#1B1B1E"
      />
    </svg>
  </IconWrapper>
  <IconWrapper v-else name="information" :color="color" fillMode="fill">
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fill-rule="evenodd"
        d="M11.34 2.281a9.709 9.709 0 0 0-6.389 2.995c-1.429 1.492-2.32 3.353-2.614 5.464-.099.709-.09 1.914.02 2.652a9.795 9.795 0 0 0 1.894 4.524c.365.489 1.336 1.459 1.833 1.832 1.912 1.433 4.158 2.114 6.506 1.971 1.96-.119 3.72-.771 5.33-1.974.488-.365 1.46-1.337 1.825-1.825 1.203-1.61 1.855-3.37 1.974-5.33a9.689 9.689 0 0 0-2.67-7.314 9.73 9.73 0 0 0-7.709-2.995m1.84 1.557a8.233 8.233 0 0 1 3.829 1.607c.425.321 1.225 1.121 1.546 1.546A8.176 8.176 0 0 1 20.24 12c0 4.187-3.103 7.682-7.279 8.198-.436.054-1.486.054-1.922 0a8.307 8.307 0 0 1-6.773-5.323c-.786-2.104-.659-4.532.343-6.532.433-.864.868-1.465 1.568-2.166.879-.878 1.824-1.491 2.948-1.911a8.455 8.455 0 0 1 4.055-.428m-1.561 3.819c-.355.213-.475.753-.246 1.099.287.435.967.434 1.254 0 .148-.223.152-.58.011-.831a.745.745 0 0 0-1.019-.268m.127 3.041a.687.687 0 0 0-.404.363c-.054.114-.062.439-.062 2.497 0 2.588-.009 2.486.238 2.694.385.324.917.208 1.152-.253l.09-.176v-2.241c0-1.512-.015-2.294-.045-2.401-.08-.288-.43-.545-.735-.539a1.016 1.016 0 0 0-.234.056"
        fill="#1B1B1E"
      />
    </svg>
  </IconWrapper>
</template>

<script setup lang="ts">
import IconWrapper from './wrapper/wrapper.vue'

import type { ColorsType } from '@/types'

const { color, filled } = defineProps<{
  color: ColorsType
  filled?: boolean
}>()
</script>
